<script>
	import Button from '$lib/components/ui/Button_2.0.svelte';
	import { twMerge } from 'tailwind-merge';
	let className = '';
	export { className as class };
	export let sectors;
</script>

<div class={twMerge('flex flex-wrap gap-4 ', className)}>
	<a href="/videos">
		<Button size="sm">All</Button>
	</a>
	<a href="/videos/free">
		<Button size="sm">Free</Button>
	</a>
	<a href="/videos/promotional">
		<Button size="sm">Product and Promotional</Button>
	</a>
	{#each sectors as sector}
		<a href={'/videos/sector/' + sector.slug}>
			<Button size="sm">{sector.name}</Button>
		</a>
	{/each}
	<a href="/playlists">
		<Button size="sm">Playlists</Button>
	</a>
</div>
